import { Component, OnInit, Input, EventEmitter, Output, Inject } from '@angular/core';
import { IPropertyFilter } from '../../../common/formbuilder/PropertyFilter';
import { FormBuilderControl, IFormBuilderControl, ILookupSelectItem } from '../../../common/formbuilder/FormBuilderControl';
import { FieldType, FilterValueType, ViewType, WhereExpressionType } from '../../core/Enums';
import { FormBuilderControlType } from '../../../common/formbuilder/FormBuilderControlType';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import * as _ from 'underscore';

@Component({
  selector: 'app-mf-filters',
  templateUrl: './mf-filters.component.html',
  styleUrls: ['./mf-filters.component.css']
})

export class MfFiltersComponent implements OnInit {
  public _filters: Array<IPropertyFilter>;
  public whereFilterTypes: Array<ILookupSelectItem> = new Array();
  public filteredLookups: any;
  @Input() showAdvancedFilters: boolean;
  public untouchedCols: any;
  @Input()
  set filters(val) {
    this._filters = val;
  }
  get filters() {
    return this._filters;
  }

  @Input() set columns(value) {
    value.filter(o => o.formBuilderControl && o.formBuilderControl.controlType.viewType == ViewType.DateTime).forEach(o => {
      o.formBuilderControl.controlType.viewType = ViewType.DateRange;
      o.whereExpressionType = WhereExpressionType.DateRange;
      o.valuType = FilterValueType.DateTime
    })

    this.untouchedCols = value;
    this._columns =
      value.map(item => {
        return { label: item.name, value: item.field }
      });
    ;

    this.filteredLookups = this._columns;
  }
  @Output() filtersChange = new EventEmitter();
  @Output() onAdvancedFilterSearch = new EventEmitter();
  @Output() onFilterTable = new EventEmitter();
  public advancedPopupVisible: boolean = false;
  public _columns: any;

  public data: any = {};
  constructor(@Inject(MAT_DIALOG_DATA) private config: any, private ref: MatDialogRef<MfFiltersComponent>) {
    this.columns = config.columns;
    this.filters = config.filters;
    this.showAdvancedFilters = config.showAdvancedFilters;
  }

  ngOnInit() {
    this.whereFilterTypes.push({ label: "And", value: 1 });
    this.whereFilterTypes.push({ label: "Or", value: 2 });
  }

  filterTable() {
    this.ref.close(this.filters)
  }

  advancedFilterSearch() {
    this.ref.close(this.filters)
  }

  filterDropdownChange(evt, filter) {
    var selected = this.untouchedCols.filter(function (o) {
      return o.field == evt;
    });
    if (selected.length > 0) {
      if (selected[0].formBuilderControl) {
        filter.control = selected[0].formBuilderControl;
        filter.whereExpressionType = selected[0].whereExpressionType;
        filter.valueType = selected[0].valueType;
      }
      else {
        let dateIssued = new FormBuilderControl();
        dateIssued.controlType = new FormBuilderControlType(FieldType.String, null);
        dateIssued.displayName = selected[0].name;
        dateIssued.bindingValue = selected[0].dbField;
        dateIssued.field = selected[0].dbField;
        dateIssued.show = function (scope) {
          return true;
        };
      }
    }
  }

  public removeAdvancedFilter(filter) {
    this.filters.splice(this.filters.indexOf(filter), 1);
  }

  public clearAdvancedFilter() {
    var arrToRemove = new Array();
    this.filters.forEach(o => {
      o.filterValue = '';
      if (o.isAdvancedFilter)
        arrToRemove.push(o);
    })

    arrToRemove.forEach(o => {
      this.filters.splice(this.filters.indexOf(o), 1);
    });

  }

  handleFilter(value) {
    if (value == null || value == "")
      this.filteredLookups = this._columns;
    else
      this.filteredLookups = _.filter(this._columns, s => s.label.toLowerCase().indexOf(value.toLowerCase()) !== -1);
  }

}
